import React from "react";
import { Grid, Box, Typography, Button, Avatar } from "@mui/material";

const NotificationPage = () => {
  const notifications = [

    {
      id: 4,
      name: "Ahmed Hassan",
      time: "1 hour ago",
      description: "Logged out at 07:30",
      action: "View detail",
      type: "CRM",
      color: "#EAE2F8",
    },
    {
      id: 1,
      name: "John Smith",
      time: "1 hour ago",
      description: "issued the invoice for Savorybites certification payment",
      action: "View Invoice",
      type: "Finance",
      color: "#FFE8E8",
    },
    {
      id: 2,
      name: "Ahmed Hassan",
      time: "1 hour ago",
      description: "logged in at 10:10",
      action: "View detail",
      type: "CRM",
      color: "#EAE2F8",
    },
    {
      id: 3,
      name: "Ahmed Hassan",
      time: "1 hour ago",
      description:
        "Mentioned you in Product listing page contact him and take the following action",
      message:
        "Please review the following things @Atif khan And Eurypylus, son of Euaemon, killed Hypsenor, the son of noble Dolopion, who had been made priest of the river Scamander, and was honoured among the people as though he were a god.",
      action: "View",
      type: "Finance",
      color: "#FFE8E8",
    },
    {
      id: 4,
      name: "Ahmed Hassan",
      time: "1 hour ago",
      description: "Logged out at 07:30",
      action: "View detail",
      type: "CRM",
      color: "#EAE2F8",
    },
    {
      id: 2,
      name: "Ahmed Hassan",
      time: "1 hour ago",
      description: "logged in at 10:10",
      action: "View detail",
      type: "CRM",
      color: "#EAE2F8",
    },

  ];

  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "20px auto",
        padding: "20px",
        background: "#F9FAFC",
        borderRadius: "12px",
        overflowY:"auto",
        height:"100%"
      }}
    >
      {notifications.map((item, index) => (
        <Grid
          container
          key={index}
          sx={{
            padding: "15px",
            background: "#EDF3FA",
            borderRadius: "12px",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
            marginBottom: "16px",
          }}
        >
          {/* Avatar and Name */}
          <Grid item xs={2}>
            <Avatar
              sx={{
                backgroundColor: "#FFD580",
                color: "#000",
                fontWeight: "bold",
              }}
            >
              {item.name.split(" ").map((word) => word[0]).join("")}
            </Avatar>
          </Grid>
          <Grid item xs={7}>
            <Typography
              sx={{ fontSize: "14px", fontWeight: "bold", marginBottom: "4px" }}
            >
              {item.name}
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "#666" }}>
              {item.description}
            </Typography>
            {item.message && (
              <Box
                sx={{
                  background: "#EDF3FA",
                  padding: "10px",
                  marginTop: "8px",
                  borderRadius: "8px",
                  border: "1px solid #E0E0E0",
                }}
              >
                <Typography sx={{ fontSize: "13px", color: "#555" }}>
                  {item.message}
                </Typography>
              </Box>
            )}
          </Grid>

          {/* Time and Action */}
          <Grid item xs={3} container direction="column" alignItems="flex-end">
            <Typography
              sx={{
                fontSize: "12px",
                color: "#888",
                marginBottom: "8px",
                textAlign: "right",
              }}
            >
              {item.time}
            </Typography>
            <Button
              variant="outlined"
              sx={{
                textTransform: "none",
                fontSize: "12px",
                padding: "4px 8px",
                borderRadius: "8px",
                borderColor: "#888",
                bgcolor:"white",
                color: "#444",
                "&:hover": {
                  borderColor: "white",
                },
              }}
            >
              {item.action}
            </Button>
          </Grid>

          {/* Tag */}
          <Grid item xs={12}  sx={{display:"flex",alignItems:"flex-end",justifyContent:"flex-end",my:1}}>
            <Box
              sx={{
                background: item.color,
                color: "#444",
                fontSize: "12px",
                fontWeight: "bold",
                textAlign: "right",
                padding: "4px 8px",
                borderRadius: "8px",
                display: "inline-block",
                marginTop: "10px",
                
              }}
            >
              {item.type}
            </Box>
          </Grid>
        </Grid>
      ))}
    </Box>
  );
};

export default NotificationPage;
